<template>
  <dialog-v2
    :show="dialog"
    title="Seleccionar carga"
    save-button-text="Aceptar"
    max-width="400px"
    @close="$emit('close')"
    @save="save">
    <template slot="content">
      <v-layout row wrap>
        <v-flex xs12>
          <v-select
            v-model="companyLoad"
            label="Carga"
            color="black"
            :items="companyLoads"
            return-object
            item-text="name"
            item-value="id"/>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import DialogV2 from '@/components/global/DialogV2';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    DialogV2,
  },
  data() {
    return {
      dialog: false,
      companyLoad: {},
      companyLoads: [],
    };
  },
  methods: {
    save() {
      if (this.companyLoad.id) {
        this.$emit('save', this.companyLoad);
        this.$emit('close');
        setTimeout(() => {
          this.companyLoad = {};
        }, 200);
      }
    },
  },
  watch: {
    show() {
      if (this.show && !this.companyLoads.length) {
        this.axios.get('company_loads').then((response) => {
          this.companyLoads = response.data;
          this.dialog = this.show;
        }).catch(() => {});
      } else {
        this.dialog = this.show;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CompanyLoad/Dialog.vue